import { FAILURE, REQUEST, SUCCESS } from 'src/redux/constants';
import { PUT_TAKING_SURVEY } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { IPutAllQuestions, PutTakingSurveyActionTypes } from './types';
import api from 'src/utils/api';

export const putTakingSurvey =
  (
    hash: string,
    data: IPutAllQuestions,
  ): ThunkAction<Promise<void>, State, null, PutTakingSurveyActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: PUT_TAKING_SURVEY + REQUEST });
    try {
      const payload = await api.putTakingSurvey(hash, data);
      dispatch({ type: PUT_TAKING_SURVEY + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: PUT_TAKING_SURVEY + FAILURE, error });
    }
  };
